import React from 'react';

const StatItem = ({
  type = 'simple',
  value,
  label,
  subtext,
  icon,
  highlightColor = '#E0582C',
  bgColor = '#EDF8FF',
}) => {
  const baseStyle = {
    padding: 16,
    borderRadius: 12,
    backgroundColor: bgColor,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    minHeight: 140,
  };

  const iconStyle = {
    width: 32,
    height: 32,
    marginBottom: 12,
  };

  const labelStyle = {
    fontSize: 16,
    fontWeight: 600,
    color: '#212121',
    lineHeight: '22px',
    marginBottom: 8,
  };

  const valueStyle = {
    fontSize: 28,
    fontWeight: 600,
    color: highlightColor,
    lineHeight: '36px',
    marginBottom: subtext ? 4 : 0,
  };

  const subtextStyle = {
    fontSize: 13,
    color: '#444',
    lineHeight: '20px',
  };

  return (
    <div style={baseStyle}>
      {type === 'icon' && icon && <img src={icon} alt="icon" style={iconStyle} />}

      {type === 'split' ? (
        <>
          {value && <div style={valueStyle}>{value}</div>}
          <div>
            {label && <span style={labelStyle}>{label} </span>}
            {subtext && <div style={subtextStyle}>{subtext}</div>}
          </div>
        </>
      ) : (
        <>
          {label && <div style={labelStyle}>{label}</div>}
          {value && <div style={valueStyle}>{value}</div>}
          {type === 'subtext' && subtext && <div style={subtextStyle}>{subtext}</div>}
          {type === 'icon' && subtext && <div style={subtextStyle}>{subtext}</div>}
        </>
      )}
    </div>
  );
};

export default StatItem;